export const ClinicControllerFactory = ({
  clinicService,
}: {
  clinicService: IClinicService;
}) => {
  return {
    getClinicFloor: clinicService.getClinicFloor,
    getMyClinics: clinicService.getMyClinics,
    getSelectedClinic: clinicService.getSelectedClinic,
    setDefaultClinic: clinicService.setDefaultClinic,
    setSelectedClinic: clinicService.setSelectedClinic,
    setClinicFloor: clinicService.setClinicFloor,
    logError: clinicService.logError,
    updateFacilityInformation: clinicService.updateFacilityInformation,
    getClinicContactInfo: clinicService.getClinicContactInfo,
    replaceClinicContactInfo: clinicService.replaceClinicContactInfo,
    patchClinicContactInfo: clinicService.patchClinicContactInfo,
    getPsnSettings: clinicService.getPsnSettings,
    patchPsnSettings: clinicService.patchPsnSettings,
    getClinicConfig: clinicService.getClinicConfig,
    patchClinicConfig: clinicService.patchClinicConfig,
    getClinicShiftReportConfig: clinicService.getClinicShiftReportConfig,
  };
};
